import React, { useEffect, useRef } from 'react';

const ContextMenu = ({ options, onAction, onClose, className = '' }) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  return (
    <div 
      ref={menuRef}
      className={`bg-white border border-gray-200 rounded-lg shadow-lg z-20 min-w-[140px] py-1 ${className}`}
      role="menu"
      aria-orientation="vertical"
    >
      {options.map((option) => {
        const IconComponent = option.icon;
        
        return (
          <button
            key={option.id}
            className={`w-full px-3 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2 transition-colors ${
              option.className || ''
            } ${option.disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            onClick={() => !option.disabled && onAction(option.id)}
            disabled={option.disabled}
            role="menuitem"
          >
            {IconComponent && <IconComponent className="w-3 h-3" />}
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default ContextMenu;